import { ListEmailsRequest, TagAutomation } from '../api/models';

export interface EmailFilters {
  search: string;
  disposition: string;
  tags: string[];
  classifications: string[];
  hideAutomation: boolean;
}

export const defaultEmailFilters: EmailFilters = {
  search: '',
  disposition: '',
  tags: [],
  classifications: [],
  hideAutomation: true,
};

const params = {
  search: 'q',
  disposition: 'disposition',
  tags: 'tag',
  classifications: 'class',
  automation: 'automation',
} as const;

const automationShown = 'shown';

function splitList(raw: string | null): string[] {
  return (raw ?? '')
    .split(',')
    .map((v) => v.trim())
    .filter((v) => v !== '');
}

export function filtersFromParams(search: URLSearchParams): EmailFilters {
  return {
    search: search.get(params.search) ?? '',
    disposition: search.get(params.disposition) ?? '',
    tags: splitList(search.get(params.tags)),
    classifications: splitList(search.get(params.classifications)),
    hideAutomation: search.get(params.automation) !== automationShown,
  };
}

export function filtersToParams(prev: URLSearchParams, filters: EmailFilters): URLSearchParams {
  const next = new URLSearchParams(prev);
  const set = (key: string, value: string) => (value ? next.set(key, value) : next.delete(key));
  set(params.search, filters.search);
  set(params.disposition, filters.disposition);
  set(params.tags, filters.tags.join(','));
  set(params.classifications, filters.classifications.join(','));
  set(params.automation, filters.hideAutomation ? '' : automationShown);
  return next;
}

// Choosing the Automation tag explicitly wins over hiding it.
export function listRequestForFilters(filters: EmailFilters): ListEmailsRequest {
  const hide = filters.hideAutomation && !filters.tags.includes(TagAutomation);
  return {
    tag: filters.tags.length ? filters.tags.join(',') : undefined,
    excludeTag: hide ? TagAutomation : undefined,
    classification: filters.classifications.length ? filters.classifications.join(',') : undefined,
    search: filters.search || undefined,
    disposition: filters.disposition || undefined,
  };
}
